import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface LoginPageProps {
  onLogin: () => void;
}
export function LoginPage({
  onLogin
}: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      onLogin();
    }, 1000);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A2F14] via-[#1B5E20] to-[#2E7D32]" data-id="element-1399" data-mp="k8g2xsyypeqh">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-1400" data-mp="g5jrcm7uaiw1"></div>

      <div className="relative z-10 w-full max-w-md p-8 bg-white rounded-2xl shadow-2xl" data-id="element-1401" data-mp="68f4sla30lep">
        <div className="flex flex-col items-center mb-8" data-id="element-1402" data-mp="1bev80e0x0iu">
          <div className="w-16 h-16 bg-[#1B5E20] rounded-xl flex items-center justify-center text-white mb-4 shadow-lg" data-id="element-1403" data-mp="1uruasquo0a5a">
            <ShieldCheckIcon size={32} data-id="element-1404" data-mp="1zj2kzp3tjzji" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 text-center" data-id="element-1405" data-mp="1zknfjeq4vihd">
            Bangladesh Forest Department
          </h1>
          <p className="text-sm text-gray-500 mt-1 font-medium tracking-wide" data-id="element-1406" data-mp="1psr6x9qf89yw">
            PERMIT MANAGEMENT SYSTEM
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1407" data-mp="2djn2mhxzzpbf">
          <div data-id="element-1408" data-mp="2ih52zjxy8w7t">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1409" data-mp="2ihoofamt62ql">
              Email or Username
            </label>
            <input type="text" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] focus:border-transparent transition-all" placeholder="Enter your credentials" data-id="element-1410" data-mp="23jmfsm0x6r2h" />
          </div>

          <div data-id="element-1411" data-mp="2zpxwsn9tgwtu">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1412" data-mp="2zsty8lkvi3n1">
              Password
            </label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] focus:border-transparent transition-all" placeholder="••••••••" data-id="element-1413" data-mp="2q0xsqpggjb8s" />
          </div>

          <div className="flex items-center justify-between" data-id="element-1414" data-mp="271tp5w7oq9oi">
            <label className="flex items-center gap-2" data-id="element-1415" data-mp="272bstdwofq6g">
              <input type="checkbox" className="w-4 h-4 text-[#1B5E20] rounded border-gray-300 focus:ring-[#1B5E20]" data-id="element-1416" data-mp="223s7nfpwqif5" />
              <span className="text-sm text-gray-600" data-id="element-1417" data-mp="58ch4rfn76t8">Remember me</span>
            </label>
            <button type="button" className="text-sm text-[#1B5E20] hover:underline font-medium" data-id="element-1418" data-mp="9swqvgp632z">
              Forgot password?
            </button>
          </div>

          <button type="submit" disabled={isLoading} className="w-full py-3 px-4 bg-[#1B5E20] text-white rounded-lg font-medium hover:bg-[#2E7D32] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1B5E20] transition-all disabled:opacity-70 flex items-center justify-center" data-id="element-1419" data-mp="crvc7w25uqi6">
            {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1420" data-mp="3q19p5yifsnwb"></div> : 'Sign In'}
          </button>
        </form>

        <div className="mt-8 text-center text-xs text-gray-500" data-id="element-1421" data-mp="3v4dfbw84xjw">
          &copy; {new Date().getFullYear()} Bangladesh Forest Department. All
          rights reserved.
        </div>
      </div>
    </div>;
}